import { useEffect, useState } from 'react';

export function UpdatePrompt() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });

      navigator.serviceWorker.getRegistration().then(reg => {
        if (!reg) return;
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                setWaitingWorker(newWorker);
                setShow(true);
              }
            });
          }
        });
      });
    }
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShow(false);
  };

  if (!show) return null;
  return (
    <div style={{ position: 'fixed', bottom: 20, left: 20, background: '#222', color: '#fff', padding: 16, borderRadius: 8, zIndex: 1000 }}>
      <span>A new version is available.</span>
      <button onClick={reloadPage} style={{ marginLeft: 12, color: '#222', background: '#fff', border: 'none', borderRadius: 4, padding: '4px 12px' }}>
        Refresh
      </button>
    </div>
  );
} 